<form class="bciti-autocomplete">
  <mat-form-field class="full-width" appearance="fill">
    <label class="address-autocomplete-label" *ngIf="label">{{ label }}</label>
    <div class="row">
          <input type="text" [placeholder]="placeholder" matInput [formControl]="myControl" [matAutocomplete]="auto" style="margin-top:5px" (focus)="onTouched"><i *ngIf="myControl.value && displayClearButton" (click)="clear()" class="clear-button icon-close"></i>
      </div>
      <mat-autocomplete disableRipple="true" #auto="matAutocomplete" (optionSelected)="optionsSelected($event.option.value)" [displayWith]="concatAddress">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{concatAddress(option)}}
          </mat-option>
      </mat-autocomplete>
      <div class="messages" *ngIf="!disableMessages">
        <ng-content selector="app-form-error"></ng-content>
        <ng-content selector="app-form-success"></ng-content>
      </div>
  </mat-form-field>
</form>